import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../helper/api';

const Pengeluaran = () => {
    const [form, setForm] = useState({
        user_id: 4,
        name: '',
        date: new Date().toISOString().slice(0, 10),
        amount: '',
        description: '',
        payment_method: 'cash',
        finance_account_id: '',
        finance_category_id: '',
        status: 'approved'
    });

    const [accounts, setAccounts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isOpenCategory, setIsOpenCategory] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (!token) {
            alert('Token tidak ditemukan di URL!');
            return;
        }

        axios.get(`${API_URL}/finance-accounts?token=${token}`)
            .then(res => setAccounts(res.data.data))
            .catch(err => console.error('Gagal ambil akun', err));

        axios.get(`${API_URL}/finance-categories?token=${token}`)
            .then(res => {
                const debitCategories = res.data.data.filter(c => c.type === 'debit');
                setCategories(debitCategories);
            })
            .catch(err => console.error('Gagal ambil kategori', err));
    }, []);


    const handleChange = (e) => {
        const { name, value, type } = e.target;
        if (type === 'file') {
            setForm({ ...form, [name]: e.target.files[0] });
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const handleCategorySelect = (categoryId) => {
        setForm({
            ...form,
            finance_category_id: categoryId
        });
        setIsOpenCategory(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        if (!token) {
            alert('Token tidak ditemukan di URL!');
            return;
        }

        const data = {
            ...form,
            user_id: 4, // hardcoded sesuai kebutuhan
            status: 'approved', // default value biar gak perlu input
        };

        try {
            await axios.post(`${API_URL}/expenses?token=${token}`, data);
            alert('Berhasil input pengeluaran!');
            setForm({ ...form, name: '', amount: '', description: '', receipt: null });
        } catch (err) {
            console.error(err);
            alert('Gagal input pengeluaran');
        }
    };

    const paymentMethods = [
        {
            value: 'cash',
            label: 'CASH',
            icon: '💵',
            gradient: 'from-emerald-500 to-teal-600'
        },
        {
            value: 'bank_transfer',
            label: 'BANK TRANSFER',
            icon: '🏦',
            gradient: 'from-blue-500 to-indigo-600'
        },
        {
            value: 'qris',
            label: 'QRIS',
            icon: '📱',
            gradient: 'from-purple-500 to-pink-600'
        }
    ];

    const selectedCategory = categories.find(cat => cat.id === form.finance_category_id);



    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 p-4 flex items-center justify-center">
            <div className="max-w-md w-full bg-white/80 backdrop-blur-lg rounded-3xl shadow-xl border border-white/20 p-8 relative overflow-hidden">
                {/* Animated background elements */}
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                    <div className="absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-br from-indigo-400/20 to-purple-400/20 rounded-full blur-2xl animate-pulse"></div>
                    <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-gradient-to-br from-pink-400/20 to-rose-400/20 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                </div>

                {/* Header */}
                <div className="text-center mb-8 relative z-10">
                    <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
                        Input Pengeluaran
                    </h1>
                    <p className="text-gray-600 text-sm">Catat pengeluaran katsikat dengan mudah</p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-5">
                    {/* Akun Keuangan */}
                    <div>
                        <p className="text-lg font-bold text-gray-800 mb-3">Pilih Akun Pembayaran</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {accounts.map(acc => (
                                <label
                                    key={acc.id}
                                    className={`
                    relative flex items-center justify-between
                    p-4 border border-gray-300 rounded-lg cursor-pointer
                    transition-all duration-300 ease-in-out
                    hover:shadow-md hover:border-blue-400
                    ${form.finance_account_id == acc.id
                                            ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-400 shadow-lg'
                                            : 'bg-white'
                                        }
                `}
                                >
                                    <input
                                        type="radio"
                                        name="finance_account_id"
                                        value={acc.id}
                                        checked={form.finance_account_id == acc.id}
                                        onChange={handleChange}
                                        className="hidden"
                                    />
                                    <span className={`text-base font-semibold ${form.finance_account_id == acc.id ? 'text-blue-800' : 'text-gray-700'}`}>
                                        {acc.name}
                                    </span>
                                    {form.finance_account_id == acc.id && (
                                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                    )}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="space-y-6 relative z-10">
                        <div className="group">
                            <label htmlFor="name" className="block mt-10 text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-indigo-600 transition-colors">
                                Nama Pengeluaran
                            </label>
                            <div className="relative">
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={form.name}
                                    onChange={handleChange}
                                    placeholder="Contoh: Beli deterjen"
                                    required
                                    className="w-full px-4 py-4 bg-gray-50/50 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-indigo-500 focus:bg-white transition-all duration-300 placeholder-gray-400 hover:border-gray-300 hover:bg-gray-50"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl opacity-0 group-focus-within:opacity-10 transition-opacity pointer-events-none"></div>
                            </div>
                        </div>

                        {/* Tanggal */}
                        <div className="group">
                            <label htmlFor="date" className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-indigo-600 transition-colors">
                                Tanggal
                            </label>
                            <div className="relative">
                                <input
                                    id="date"
                                    name="date"
                                    type="date"
                                    value={form.date}
                                    onChange={handleChange}
                                    className="w-full px-4 py-4 bg-gray-50/50 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-indigo-500 focus:bg-white transition-all duration-300 hover:border-gray-300 hover:bg-gray-50"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl opacity-0 group-focus-within:opacity-10 transition-opacity pointer-events-none"></div>
                            </div>
                        </div>

                        {/* Jumlah Uang */}
                        <div className="group">
                            <label htmlFor="amount" className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-indigo-600 transition-colors">
                                Jumlah (Rp)
                            </label>
                            <div className="relative">
                                <input
                                    id="amount"
                                    name="amount"
                                    type="number"
                                    value={form.amount}
                                    onChange={handleChange}
                                    placeholder="Contoh: 50000"
                                    required
                                    className="w-full px-4 py-4 bg-gray-50/50 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-indigo-500 focus:bg-white transition-all duration-300 placeholder-gray-400 hover:border-gray-300 hover:bg-gray-50"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl opacity-0 group-focus-within:opacity-10 transition-opacity pointer-events-none"></div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                                Keterangan (Opsional)
                            </label>
                            <textarea
                                id="description"
                                name="description"
                                value={form.description}
                                onChange={handleChange}
                                placeholder="Contoh: Beli sabun, ke Indomaret"
                                rows={3}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                            />
                        </div>


                        <div className="max-w-2xl mx-auto bg-gradient-to-br from-gray-50 to-white rounded-3xl">
                            <div className="space-y-6">
                                <div className="text-center">
                                    <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
                                        Metode Pembayaran
                                    </h3>
                                    <p className="text-gray-500 text-sm">Pilih metode pembayaran yang kamu gunakan</p>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                                    {paymentMethods.map((method) => {
                                        const isSelected = form.payment_method === method.value;
                                        return (
                                            <label
                                                key={method.value}
                                                className={`relative group cursor-pointer transition-all duration-300 transform hover:scale-105 ${isSelected ? 'scale-105' : ''
                                                    }`}
                                            >
                                                <input
                                                    type="radio"
                                                    name="payment_method"
                                                    value={method.value}
                                                    checked={isSelected}
                                                    onChange={handleChange}
                                                    className="hidden"
                                                />

                                                <div className={`
                  relative overflow-hidden rounded-2xl p-6 border-2 transition-all duration-300
                  ${isSelected
                                                        ? `bg-gradient-to-br ${method.gradient} text-white border-transparent shadow-2xl`
                                                        : 'bg-white hover:bg-gray-50 text-gray-700 border-gray-200 hover:border-gray-300 shadow-md hover:shadow-lg'
                                                    }
                `}>
                                                    {/* Animated background for selected state */}
                                                    {isSelected && (
                                                        <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent animate-pulse"></div>
                                                    )}

                                                    {/* Icon */}
                                                    <div className="text-center mb-3">
                                                        <span className={`text-3xl ${isSelected ? 'animate-bounce' : 'group-hover:animate-pulse'}`}>
                                                            {method.icon}
                                                        </span>
                                                    </div>

                                                    {/* Label */}
                                                    <div className="text-center relative z-10">
                                                        <span className={`font-bold text-sm tracking-wide ${isSelected ? 'text-white' : 'text-gray-700'
                                                            }`}>
                                                            {method.label}
                                                        </span>
                                                    </div>

                                                    {/* Selection indicator */}
                                                    {isSelected && (
                                                        <div className="absolute top-2 right-2 w-6 h-6 bg-white/30 rounded-full flex items-center justify-center">
                                                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                            </svg>
                                                        </div>
                                                    )}

                                                    {/* Hover effect ring */}
                                                    <div className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${!isSelected ? 'ring-2 ring-gray-300/50' : ''
                                                        }`}></div>
                                                </div>
                                            </label>
                                        );
                                    })}
                                </div>

                                {/* Selected method display */}
                                {form.payment_method && (
                                    <div className="text-center p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-100">
                                        <p className="text-sm text-gray-600 mb-1">Metode pembayaran terpilih:</p>
                                        <p className="font-semibold text-indigo-600">
                                            {paymentMethods.find(m => m.value === form.payment_method)?.label}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>


                        <div className="max-w-md mx-auto p-6 bg-gradient-to-br from-gray-50 to-white rounded-3xl">
                            <div className="space-y-4">
                                <div className="text-center mb-6">
                                    <h3 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-1">
                                        Kategori Pengeluaran
                                    </h3>
                                    <p className="text-gray-500 text-sm">Pilih kategori yang sesuai dengan pengeluaranmu</p>
                                </div>

                                {/* Custom Select Button */}
                                <div className="relative">
                                    <button
                                        type="button"
                                        onClick={() => setIsOpenCategory(!isOpenCategory)}
                                        className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 text-left flex items-center justify-between ${selectedCategory
                                            ? 'border-indigo-300 bg-gradient-to-r from-indigo-50 to-purple-50 text-gray-800'
                                            : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50 text-gray-500'
                                            } focus:outline-none focus:ring-4 focus:ring-indigo-100 shadow-md hover:shadow-lg`}
                                    >
                                        <div className="flex items-center space-x-3">
                                            {selectedCategory ? (
                                                <>
                                                    <span className="text-2xl">{selectedCategory.icon}</span>
                                                    <span className="font-semibold text-gray-800">{selectedCategory.name}</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="text-2xl">📋</span>
                                                    <span>Pilih Kategori</span>
                                                </>
                                            )}
                                        </div>

                                        <svg
                                            className={`w-5 h-5 transition-transform duration-300 ${isOpenCategory ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>

                                    {/* Dropdown Options */}
                                    {isOpenCategory && (
                                        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-2xl shadow-2xl z-50 max-h-80 overflow-y-auto">
                                            <div className="p-2">
                                                {categories.map((category) => (
                                                    <button
                                                        key={category.id}
                                                        onClick={() => handleCategorySelect(category.id)}
                                                        className={`w-full p-3 rounded-xl text-left transition-all duration-200 flex items-center space-x-3 group ${form.finance_category_id === category.id
                                                            ? `bg-gradient-to-r ${category.color} text-white shadow-lg`
                                                            : 'hover:bg-gray-50 text-gray-700'
                                                            }`}
                                                    >
                                                        <span className={`text-xl ${form.finance_category_id === category.id
                                                            ? 'animate-bounce'
                                                            : 'group-hover:animate-pulse'
                                                            }`}>
                                                            {category.icon}
                                                        </span>
                                                        <span className="font-medium">{category.name}</span>

                                                        {form.finance_category_id === category.id && (
                                                            <div className="ml-auto">
                                                                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Selected Category Display */}
                                {selectedCategory && (
                                    <div className={`p-4 rounded-2xl bg-gradient-to-r text-black text-white text-center transform transition-all duration-300 animate-fadeIn`}>
                                        <div className="flex items-center justify-center space-x-2 mb-2">
                                            <span className="text-2xl animate-pulse">{selectedCategory.icon}</span>
                                            <span className="font-bold">Kategori Terpilih</span>
                                        </div>
                                        <p className="text-white-90 text-sm">
                                            Pengeluaran akan dicatat dalam kategori "{selectedCategory.name}"
                                        </p>
                                    </div>
                                )}

                                {/* Hidden select for form compatibility */}
                                <select
                                    name="finance_category_id"
                                    value={form.finance_category_id}
                                    onChange={handleChange}
                                    className="hidden"
                                    required
                                >
                                    <option value="">Pilih Kategori</option>
                                    {categories.map(cat => (
                                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Bukti */}
                        {/* <div>
                    <p className="font-semibold mb-1">Upload Bukti (Opsional)</p>
                    <input type="file" name="receipt" onChange={handleChange} className="w-full" accept="image/*" />
                </div> */}
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">Kirim</button>
                    <div className="absolute top-4 right-4 w-2 h-2 bg-indigo-400 rounded-full animate-ping"></div>
                    <div className="absolute bottom-4 left-4 w-1 h-1 bg-purple-400 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
                </form>
            </div>
        </div>
    );
};

export default Pengeluaran;
